module.exports = __webpack_public_path__ + "img/history-of-humanities-cover.fe54a3a3.jpg";